import { useQuery, useQueryClient, useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useInvoiceItemTemplates = (config) => {
  return useQuery({
    ...config,
    queryKey: "invoice-item-templates",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/invoice-item-templates`,
        signal,
      }),
  });
};

export const useCreateInvoiceItemTemplate = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/invoice-item-templates`,
        method: "POST",
        body: data,
      }),
    onSuccess: (response) => {
      const previous = client.getQueryData("invoice-item-templates") || [];

      client.setQueryData("invoice-item-templates", [...previous, response.single]);
    },
  });
};

export const useUpdateInvoiceItemTemplate = (id) => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/invoice-item-templates/${id}`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries("invoice-item-templates");
    },
  });
};

export const useDeleteInvoiceItemTemplate = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      fetch({
        url: `${Angie.api_url}/invoice-item-templates/${id}`,
        method: "DELETE",
      }),
    onMutate: (id) => {
      const previous = client.getQueryData("invoice-item-templates") || [];

      client.setQueryData(
        "invoice-item-templates",
        previous.filter((item) => item.id !== id)
      );
    },
    onSuccess: () => {
      client.invalidateQueries("invoice-item-templates");
    },
  });
};
